<main>
	<div class="container">

		<div class="row mb-4">
			<div class="col general-title">
				<h2>Meus Seguros</h2>
			</div>
		</div>

        <table>
            <thead>
                <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                </tr>
            </thead>

            <tbody>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
            </tbody>
        </table>
     
    </div>
</main>        